import { styled } from '@mui/material/styles';

export const StyledBoxCardContainer = styled('div')(({ theme }) => ({
	display: 'flex',
	flexWrap: 'wrap',
	alignItems: 'stretch',
	justifyContent: 'flex-start',
	gap: theme.spacing(2),
	marginTop: theme.spacing(1),

	[theme.breakpoints.down('sm')]: {
		justifyContent: 'center',
	},
}));
